/* ===== AUTO DISCOUNT DISPLAY v3 - COLLECTION & PRODUCT PAGES ===== */
(function() {
  'use strict';

  // ---- פורמט מחיר לפי מטבע נוכחי ----
  function formatPrice(ilsCents) {
    const dgc = window.DoublyGlobalCurrency;
    if (dgc && dgc.currentCurrency && dgc.moneyFormats && dgc.convert) {
      const currency = dgc.currentCurrency;
      const convertedCents = dgc.convert(ilsCents, 'ILS', currency);
      const fmt = dgc.moneyFormats[currency]?.money_format || '{{amount}}';
      const amount = (convertedCents / 100).toFixed(2);
      return fmt
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(convertedCents / 100))
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    }
    return '&#8362;' + (ilsCents / 100).toFixed(2);
  }

  function delay(ms) {
    return new Promise(r => setTimeout(r, ms));
  }

  async function fetchJSON(url, opts) {
    const r = await fetch(url, opts);
    if (!r.ok) throw new Error(r.status);
    return r.json();
  }

  // ---- עדכון כרטיס בקטגוריה ----
  function updateCardPrice(card, pct, discountedCents, originalCents) {
    if (card.querySelector('.auto-disc-done')) return;
    card.classList.add('auto-disc-done');

    // בדג' על התמונה
    const badgeWrap = card.querySelector('.hdt-badge__wrapp');
    if (badgeWrap) {
      badgeWrap.insertAdjacentHTML('beforeend',
        `<span class="auto-disc-badge" style="background:#e00;color:#fff;padding:3px 9px;border-radius:3px;font-size:12px;font-weight:bold;display:inline-block">-${pct}%</span>`
      );
    }

    // הסתר מחיר ישן + הצג חדש
    const hdtPrice = card.querySelector('hdt-price.hdt-price');
    if (hdtPrice) {
      hdtPrice.style.display = 'none';
      hdtPrice.insertAdjacentHTML('afterend',
        `<span class="auto-disc-price" style="display:inline-flex;align-items:center;gap:6px;flex-wrap:wrap">
          <span style="color:#e00;font-weight:bold">${formatPrice(discountedCents)}</span>
          <s style="color:#aaa;font-size:0.85em">${formatPrice(originalCents)}</s>
        </span>`
      );
    }
  }

  // ---- בדיקת מוצר בודד (בטוח מ-bot detection) ----
  async function checkSingleVariant(variantId, itemKey) {
    // שמור עגלה לפני
    const cartBefore = await fetchJSON('/cart.js');
    const keysBefore = new Set(cartBefore.items.map(i => i.key));

    // הוסף מוצר
    const added = await fetchJSON('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    });

    // קרא עגלה
    const cart = await fetchJSON('/cart.js');
    const item = cart.items.find(i => i.variant_id == variantId);

    // הסר מה שנוסף
    if (item && !keysBefore.has(item.key)) {
      await fetchJSON('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      }).catch(() => null);
    }

    return item || null;
  }

  // ---- דף קטגוריה ----
  async function runCollection() {
    const cards = [...document.querySelectorAll('.hdt-card-product')];
    if (!cards.length) return;

    for (const card of cards) {
      const variantInput = card.querySelector('input[name="id"]');
      if (!variantInput) continue;

      try {
        const item = await checkSingleVariant(variantInput.value);

        if (item && item.final_price < item.original_price) {
          const pct = Math.round((1 - item.final_price / item.original_price) * 100);
          updateCardPrice(card, pct, item.final_price, item.original_price);
        }
      } catch (e) {
        // המשך לכרטיס הבא אם יש שגיאה
      }

      // השהיה בין מוצרים - מונע bot detection
      await delay(400);
    }
  }

  // ---- דף מוצר ----
  async function checkVariantProduct(variantId) {
    // נקה ישן
    document.querySelectorAll('.auto-disc-price, .auto-disc-badge').forEach(el => el.remove());
    document.querySelectorAll('hdt-price.hdt-price[style*="none"]').forEach(el => el.style.display = '');

    try {
      const item = await checkSingleVariant(variantId);
      if (!item || item.final_price >= item.original_price) return;

      const pct = Math.round((1 - item.final_price / item.original_price) * 100);

      const hdtPrice = document.querySelector('.hdt-price-wrapp hdt-price, hdt-price.hdt-price');
      if (hdtPrice) {
        hdtPrice.style.display = 'none';
        hdtPrice.insertAdjacentHTML('afterend',
          `<span class="auto-disc-price" style="display:inline-flex;align-items:center;gap:10px;flex-wrap:wrap;margin-top:4px">
            <span class="auto-disc-badge" style="background:#e00;color:#fff;padding:2px 10px;border-radius:3px;font-size:13px;font-weight:bold">-${pct}%</span>
            <span style="color:#e00;font-weight:bold;font-size:1.2em">${formatPrice(item.final_price)}</span>
            <s style="color:#aaa">${formatPrice(item.original_price)}</s>
          </span>`
        );
      }
    } catch (e) {
      // שגיאה שקטה
    }
  }

  function runProduct() {
    const variantInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
    if (!variantInput) return;

    checkVariantProduct(variantInput.value);

    document.addEventListener('change', function(e) {
      if (
        e.target.name === 'id' ||
        e.target.closest('[data-variant-selector]') ||
        e.target.closest('variant-selects')
      ) {
        setTimeout(() => {
          const v = document.querySelector('form[action="/cart/add"] input[name="id"]')?.value;
          if (v) checkVariantProduct(v);
        }, 400);
      }
    });
  }

  // ---- הפעלה ----
  function init() {
    const path = window.location.pathname;
    if (path.includes('/collections/')) runCollection();
    else if (path.includes('/products/')) runProduct();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
/* ===== END AUTO DISCOUNT DISPLAY v3 ===== */